/* Irrelevant — Inline Search Overlay (full results + paging) */
(function () {
  const overlay = document.getElementById('search-overlay');
  const input   = document.getElementById('il-search-input');
  const results = document.getElementById('il-search-results');
  if (!overlay || !input || !results) return;

  /* ---------- helpers ---------- */
  function closeAnyMobileDrawer() {
    try {
      document.querySelectorAll('details[open]').forEach(d => d.removeAttribute('open'));
      document.querySelectorAll('#m-drawer.is-open, .m-drawer.is-open, [data-drawer].is-open')
        .forEach(el => el.classList.remove('is-open'));
      const burger = document.querySelector('.m-burger[aria-expanded="true"]');
      if (burger) burger.setAttribute('aria-expanded', 'false');
    } catch {}
  }
  function priceText(cents){
    if (typeof cents !== 'number') return '';
    try {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency }).format(cents/100);
    } catch { return (cents/100).toFixed(2); }
  }
  function shopRoot(){
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  /* ---------- open / close ---------- */
  function openOverlay(e){
    if (e) e.preventDefault();
    closeAnyMobileDrawer();
    overlay.classList.remove('is-hidden');
    document.documentElement.classList.add('il-no-scroll');
    document.body.classList.add('il-no-scroll');
    setTimeout(() => input && input.focus(), 0);
  }
  function closeOverlay(){
    overlay.classList.add('is-hidden');
    document.documentElement.classList.remove('il-no-scroll');
    document.body.classList.remove('il-no-scroll');
    results.innerHTML = '';
    input.value = '';
    nextPageUrl = null;
    currentQuery = '';
    seen.clear();
    lastFetched = '';
    isFetching = false;
  }

  document.addEventListener('click', (e)=>{
    const openBtn  = e.target.closest('[data-search-open]');
    const closeBtn = e.target.closest('[data-search-close]');
    if (openBtn)  openOverlay(e);
    if (closeBtn) closeOverlay();
  });
  document.addEventListener('keydown', (e)=>{ if (e.key === 'Escape') closeOverlay(); });
  overlay.addEventListener('touchmove', (e)=>{
    if (!e.target.closest('.il-search__panel')) e.preventDefault();
  }, { passive: false });

  /* ---------- FULL search via /search?view=ajax (paged) ---------- */
  let debounceTimer = null;
  let currentQuery = '';
  let nextPageUrl = null;
  let isFetching = false;
  let lastFetched = '';
  const seen = new Set();   // de-dup by product URL (or handle)

  input.setAttribute('autocomplete', 'off');
  input.setAttribute('autocorrect', 'off');
  input.setAttribute('autocapitalize', 'off');
  input.setAttribute('spellcheck', 'false');

  input.addEventListener('input', () => {
    const q = (input.value || '').trim();
    if (debounceTimer) clearTimeout(debounceTimer);
    if (q.length < 2) { results.innerHTML = ''; currentQuery = ''; nextPageUrl = null; seen.clear(); return; }
    debounceTimer = setTimeout(() => beginSearch(q), 160);
  });

  // Expand common fashion keywords to cover title/product_type/tags + spelling variants
function expandQuery(qRaw){
  const q = qRaw.trim().toLowerCase();

  // keyword packs you care about
  const packs = [
    {
      keys: ['tshirt','tshirts','tee','tees','t shirt','t shirts','t-shirt','t-shirts'],
      ors: [
        'title:tshirt*',
        'title:t-shirt*',
        'title:tee*',
        'product_type:tshirt',
        'product_type:t-shirt',
        'product_type:tee',
        'tag:tshirt',
        'tag:t-shirt',
        'tag:tee'
      ]
    },
    {
      keys: ['hoodie','hoodies','hooded'],
      ors: [
        'title:hoodie*',
        'product_type:hoodie',
        'tag:hoodie'
      ]
    },
    {
      keys: ['sweatshirt','crew','crewneck','crew neck','sweater'],
      ors: [
        'title:crew*',
        'title:sweat*',
        'product_type:sweatshirt',
        'tag:crewneck',
        'tag:sweatshirt'
      ]
    },
    // add more packs over time (pants, joggers, shorts, jacket, bomber, knitwear…)
  ];

  const pack = packs.find(p => p.keys.some(k => q.includes(k)));
  if (pack){
    // Join with OR so Shopify returns any matching variant
    return '(' + pack.ors.join(' OR ') + ')';
  }

  // default: also try plural/singular loose match
  return `title:${q}* OR tag:${q} OR product_type:${q}`;
}

function beginSearch(q){
  currentQuery = q;
  seen.clear();
  lastFetched = '';

  const expanded = expandQuery(q); // <-- build a smarter query

  const url = `${shopRoot()}search?view=ajax&type=product&q=${encodeURIComponent(expanded)}&options[prefix]=last`;
  fetchPage(url, { append: false });
}

  results.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn || !nextPageUrl) return;
    fetchPage(nextPageUrl, { append: true, button: btn });
  });

  results.addEventListener('scroll', () => {
    if (!nextPageUrl || isFetching) return;
    const nearBottom = results.scrollTop + results.clientHeight >= results.scrollHeight - 200;
    if (nearBottom) fetchPage(nextPageUrl, { append: true });
  });

  function fetchPage(url, { append=false, button=null } = {}) {
    if (isFetching || !url || url === lastFetched) return; // single-flight + no repeated URL
    isFetching = true;
    lastFetched = url;
    if (button) { button.textContent = 'Loading…'; button.disabled = true; }

    fetch(url, { headers: { 'Accept': 'application/json' }})
      .then(r => r.json())
      .then(data => {
        renderProducts(data.products || [], { append });
        nextPageUrl = data.next_page;     // null when done
        renderLoadMore();
      })
      .catch(() => {
        if (!append) results.innerHTML = `<div style="padding:12px;opacity:.7">Couldn’t load results.</div>`;
      })
      .finally(() => {
        isFetching = false;
        if (button) { button.textContent = 'Load more'; button.disabled = false; }
      });
  }

  function renderProducts(items, { append=false } = {}) {
    const newCards = [];
    for (const p of items) {
      const key = p.url || p.title; // prefer URL as unique key
      if (seen.has(key)) continue;  // de-dup
      seen.add(key);

      newCards.push(`
        <a class="il-card" href="${p.url}">
          ${p.image ? `<img class="il-card__img" src="${p.image}" alt="${p.title.replace(/"/g,'&quot;')}">`
                    : `<div class="il-card__img"></div>`}
          <div class="il-card__meta">
            <div class="il-card__title">${p.title}</div>
            <div class="il-card__price">${p.price ? priceText(p.price) : ''}</div>
          </div>
        </a>
      `);
    }

    if (append) {
      const grid = results.querySelector('.il-grid');
      if (grid && newCards.length) grid.insertAdjacentHTML('beforeend', newCards.join(''));
    } else {
      if (newCards.length) {
        results.innerHTML = `<div class="il-grid">${newCards.join('')}</div>`;
      } else {
        results.innerHTML = `<div style="padding:12px;opacity:.7">No products found.</div>`;
      }
    }
  }

  function renderLoadMore() {
    results.querySelector('[data-load-more]')?.parentElement?.remove();
    if (!nextPageUrl) return;
    const wrap = document.createElement('div');
    wrap.style.display = 'flex';
    wrap.style.justifyContent = 'center';
    wrap.style.padding = '12px 0 4px';
    wrap.innerHTML = `<button data-load-more class="il-btn">Load more</button>`;
    results.appendChild(wrap);
  }
})();